"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M8 8h8v8H8z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M6 18h12V6H6zM8 8h8v8H8z"
}, "1")], 'StopTwoTone');